<mat-toolbar class="toolbar">
  <form class="search-form" [formGroup]="searchFormGroup">
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Chargepoint Type</mat-label>
      <mat-select formControlName="chargepointType">
        <mat-option value="all">All</mat-option>
        <mat-option value="OCPP">OCPP</mat-option>
        <mat-option value="OKECHARGE">OKECHARGE</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Trace Type</mat-label>
      <input
        matInput
        formControlName="type"
        [matAutocomplete]="traceTypeAutocomplete"
        placeholder="Search trace type..."
      />
      <mat-autocomplete
        #traceTypeAutocomplete="matAutocomplete"
        [displayWith]="displayTraceType.bind(this)">
        <mat-option *ngFor="let option of filteredTraceTypes$ | async" [value]="option.value">
          {{ option.label }}
        </mat-option>
      </mat-autocomplete>
      <button *ngIf="searchFormGroup.get('type')?.value" matSuffix mat-icon-button aria-label="Clear" (click)="searchFormGroup.controls.type.setValue('')">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Chargepoint ID</mat-label>
      <input matInput formControlName="chargepointId" placeholder="some/id ..." />
      <button *ngIf="searchFormGroup.get('chargepointId')?.value" matSuffix mat-icon-button aria-label="Clear" (click)="searchFormGroup.controls.chargepointId.setValue('')">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>From Date</mat-label>
      <input matInput [matDatepicker]="fromPicker" formControlName="from" />
      <mat-datepicker-toggle matIconButton matSuffix [for]="fromPicker"></mat-datepicker-toggle>
      <mat-datepicker #fromPicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>To Date</mat-label>
      <input matInput [matDatepicker]="toPicker" formControlName="to" />
      <mat-datepicker-toggle matIconButton matSuffix [for]="toPicker"></mat-datepicker-toggle>
      <mat-datepicker #toPicker></mat-datepicker>
    </mat-form-field>
    <mat-checkbox formControlName="errorOnly">Error only</mat-checkbox>
    <div class="spacer"></div>
    <div class="traces-count" *ngIf="result$ | async as result">
      <mat-icon [inline]="true">info</mat-icon>
      <span class="traces-count-value">{{result.total}}</span>
    </div>
  </form>
</mat-toolbar>

<mat-paginator
  [length]="(result$ | async)?.total ?? 0"
  [pageIndex]="(page$ | async)?.pageIndex ?? 0"
  [pageSize]="(page$ | async)?.pageSize ?? 25"
  [pageSizeOptions]="[25, 50, 100]"
  (page)="onPageChange($event)">
</mat-paginator>

<mat-progress-bar *ngIf="searching" mode="indeterminate"></mat-progress-bar>

<ng-container *ngIf="result$ | async as result">
  <div class="traces-list" *ngIf="result.traces.length > 0; else empty">
    <ng-container *ngFor="let trace of result.traces; let i = index">
      <mat-divider *ngIf="i"></mat-divider>
      <div class="trace-item">
        <mat-icon class="trace-icon">description</mat-icon>
        <div class="column">
          <div class="trace-name">{{trace.name}}</div>
          <div class="trace-time">{{trace.time | date : "medium"}}</div>
          <div class="trace-error-code" *ngIf="trace.errorCode">
            <mat-icon [inline]="true">error</mat-icon>
            <span>{{trace.errorCode}}</span>
          </div>
        </div>
        <div class="column">
          <div class="trace-type">{{trace.type}}</div>
          <div class="trace-chargepoint-id">
            <button mat-icon-button matTooltip="Open chargepoint details" (click)="navigateToChargepoint(trace.chargePointId)">
              <mat-icon>open_in_new</mat-icon>
            </button>
            <span matTooltip="Copy to clipboard" (click)="copyToClipboard(trace.chargePointId)">
              {{trace.chargePointId}}
              <mat-icon>content_copy</mat-icon>
            </span>
          </div>
        </div>
        <div class="spacer"></div>
        <button mat-icon-button [matTooltip]="formatPayload(trace.payload)" matTooltipPosition="left">
          <mat-icon>code</mat-icon>
        </button>
      </div>
    </ng-container>
  </div>
</ng-container>

<ng-template #empty>
  <div class="disclaimer">
    <mat-icon>sentiment_dissatisfied</mat-icon>
    <p>No traces found. Please enter search criteria to find traces.</p>
  </div>
</ng-template>

